import { BulkActionStatus } from '../../bulk.actions/enums';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const UserRoomEventType = {
    AuthSessionRevoked: 'auth-session-revoked',
    BulkActionStarted: 'bulk-action:started',
    BulkActionProgressed: 'bulk-action:progressed',
    BulkActionCompleted: 'bulk-action:completed',
} as const;

export interface BulkActionUserRoomPayload {
    headerId: string;
    entity: ActivityEntityName;
    status: BulkActionStatus;
    total: number;
    success: number;
    skipped: number;
    failed: number;
}

export type UserRoomMessage =
    | SocketRoomEvent<typeof UserRoomEventType.AuthSessionRevoked, { sessionId?: string; reason?: string }>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionStarted, BulkActionUserRoomPayload>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionProgressed, BulkActionUserRoomPayload>
    | SocketRoomEvent<typeof UserRoomEventType.BulkActionCompleted, BulkActionUserRoomPayload>;

export const UserRooms = {
    user: (userId: string): RoomKey<UserRoomMessage> => ({ key: userId }),
};
